<template>
  <form-section id="supplier" :headline="this.$t('form.parties.supplier.headline')">
    <textfield
      id="supplier_name"
      :label="$t('form.parties.supplier.name.label')"
      :placeholder="$t('form.parties.supplier.name.placeholder')"
      v-model="supplier.name"
      isRequired
    />

    <div class="form-group">
      <label for="supplier_cvr">{{ $t('form.parties.supplier.cvr.label') }}</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          id="supplier_cvr"
          maxlength="8"
          minlength="8"
          :placeholder="$t('form.parties.supplier.cvr.placeholder')"
          v-model="supplier.cvr"
          @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
          @blur="validateRequired"
          required
        />
        <div class="invalid-feedback">
          <invalid-cross></invalid-cross>
          <span>{{ $t('form.shared.cvr_error') }}</span>
        </div>
      </div>
    </div>

    <textfield
      id="supplier_address"
      :label="$t('form.parties.supplier.address.label')"
      :placeholder="$t('form.parties.supplier.address.placeholder')"
      v-model="supplier.address"
      isRequired
    />

    <textfield
      id="supplier_zip_city"
      :label="$t('form.parties.supplier.zip_city.label')"
      :placeholder="$t('form.parties.supplier.zip_city.placeholder')"
      v-model="supplier.zipCity"
      isRequired
    />

    <textfield
      id="supplier_country"
      :label="$t('form.parties.supplier.country.label')"
      :placeholder="$t('form.parties.supplier.country.placeholder')"
      v-model="supplier.country"
      isRequired
    />
  </form-section>
</template>

<script>
import FormSection from "@/shared/components/FormSection.vue";
import Textfield from "@/shared/components/Textfield.vue";
export default {
  components: {
    FormSection,
    Textfield
  },
  data() {
    return {
      supplier: {
        name: "",
        cvr: "",
        address: "",
        zipCity: "",
        country: ""
      }
    };
  },
  watch: {
    supplier: {
      handler() {
        this.supplier.cvr = this.restrictNumber(this.supplier.cvr);
        this.$store.commit("updateSupplier", this.supplier);
      },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/form/parties/SupplierInput.vue